export const storeOptionValues = [
  { id: 'GLOBAL', name: 'Global' },
  { id: 'EU', name: 'Eu' }
];
